import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core'

@Component({
  selector: 'app-expedia-listing-wizard-step3',
  templateUrl: './expedia-listing-wizard-step3.component.html',
  styleUrls: ['./expedia-listing-wizard-step3.component.scss'],
})
export class ExpediaListingWizardStep3Component implements OnInit {
  @Output() prev = new EventEmitter()
  @Output() done = new EventEmitter()
  constructor() {}

  ngOnInit(): void {}
}
